import BookingsListPage from '../../shared/booking/BookingsListPage';

export default function InsuranceBookings() {
  return <BookingsListPage module="insurance" title="My insurance policies" />;
}
